import React from 'react';
import Section from '../section/section';
import SubSection from '../section/sub-section';

export default class MultiStepSetup extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      currentStep: 0,
    };
  }

  render() {
    return <Section title="Instructions">
      <div className="row justify-content-center">
        <div className="col-12 col-md-9">
          {this.props.steps
            .filter((step, i) => i <= this.state.currentStep)
            .map((step, i) =>
              <SubSection key={i} title={step.title} className="my-4">
                {step.component}
              </SubSection>
            )
          }
          <div className="card my-4">
            <div className="card-body">
              <div className="row justify-content-center">
                <div className="col-auto">
                  {this.state.currentStep < this.props.steps.length ?
                    <button type="button"
                            className="col btn btn-success px-5"
                            onClick={() => this.setState(prevState => ({currentStep: prevState.currentStep + 1}))}>
                      {this.state.currentStep >= this.props.steps.length - 1 ? 'Done' : 'Next'}
                    </button> :
                    <div className="row justify-content-center">
                      <div className="col-auto h4">Nice job!</div>
                      <div className="w-100" />
                      {this.props.callToAction}
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Section>;
  }

}
